/**
 * Helpers per notifiche account: tesseramenti/soci pending + ordini non-tessera.
 * userData.tesseramenti = array di Soci (con nested socio.tesseramenti[]).
 */

export function getPendingSoci(userData) {
  const soci = userData?.tesseramenti || [];
  const currentYear = new Date().getFullYear();

  return soci.filter((socio) => {
    if (socio?.paymentStatus === 'pending') return true;

    const nested = socio?.tesseramenti || [];
    return nested.some(
      (t) =>
        t?.paymentStatus === 'pending' &&
        (!t.anno || Number(t.anno) === currentYear)
    );
  });
}

export function getPendingNonTesseraOrders(userData) {
  return (userData?.orders || []).filter(
    (order) => order.paymentStatus === 'pending' && !order.tesseramento
  );
}

export function getPendingNotificationsCount(userData) {
  if (!userData) return 0;
  return (
    getPendingSoci(userData).length +
    getPendingNonTesseraOrders(userData).length
  );
}
